import { Link } from 'react-router-dom';
import { Button } from '@mantine/core';
import { IconHome, IconMapQuestion } from '@tabler/icons-react';
import { useEnrichedAuth } from '@/hooks/useEnrichedAuth';
import { EmptyState } from '@/components/ui';
import { useCopy } from '@/lib/settings';

export default function NotFound() {
  const { isAuthenticated } = useEnrichedAuth();
  const { t } = useCopy();
  return (
    <div className="rides-main">
      <h1 className="sr-only">Page not found</h1>
      <div style={{ paddingTop: 24 }}>
        <EmptyState
          icon={<IconMapQuestion size={30} />}
          title="We couldn't find that page"
          action={
            isAuthenticated
              ? <Button component={Link} to="/home" fullWidth leftSection={<IconHome size={20} />}>Back to Home</Button>
              : <Button component={Link} to="/" fullWidth leftSection={<IconHome size={20} />}>Go to the start</Button>
          }
        >
          {t('notfound.message')}
        </EmptyState>
      </div>
    </div>
  );
}
